import React from 'react'; // Не убирать  не будет работать 
import { useSelector } from "react-redux";

import styles from './index.module.scss';
import Spinner from 'react-bootstrap/Spinner';

const DAY_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const ERROR_TYPE_LABEL = {
    sameTeacher: 'Teacher Conflict',
    sameLevels: 'Level Conflict',
    teacherAvailableTime: 'Teacher Availability',
    teacherLevelAssignment: 'Level Assignment',
    outOfWorkingHours: 'Working Hours',
    studentOverlap: 'Student Overlap',
};

// Left-border accent + tag colors per error type — warm palette only
const ERROR_TYPE_STYLE = {
    sameTeacher:           { border: '#e07b00', tagBg: '#fff4e0', tagColor: '#a85800', tagBorder: '#fdd9a0' },
    sameLevels:            { border: '#d4a017', tagBg: '#fffbea', tagColor: '#8a6300', tagBorder: '#fce89a' },
    teacherAvailableTime:  { border: '#e03c00', tagBg: '#fff2ee', tagColor: '#a82a00', tagBorder: '#fdc5b0' },
    teacherLevelAssignment:{ border: '#c8860a', tagBg: '#fff8e6', tagColor: '#8a5a00', tagBorder: '#fddfa0' },
    outOfWorkingHours:     { border: '#c0392b', tagBg: '#fff0ee', tagColor: '#8b1a10', tagBorder: '#f5bfba' },
    studentOverlap:        { border: '#e05c00', tagBg: '#fff3ec', tagColor: '#a03d00', tagBorder: '#fdc8a0' },
};

const getErrorStyle = (errorType) =>
    ERROR_TYPE_STYLE[errorType] || { border: '#aaa', tagBg: '#f5f5f5', tagColor: '#555', tagBorder: '#ddd' };

const HistoryNotification = ({ setIsOpenHistoryNotification, onErrorClick }) => {
    const scheduleErrors = useSelector((state) => state.events.scheduleErrors);
    const { loadingErrors } = useSelector(state => state.events);

    const handleErrorClick = (item) => {
        if (onErrorClick && item.sticker) {
            // Use the error's dayOfTheWeek (which is correctly categorised)
            // rather than sticker.dayOfTheWeek which can differ due to data model
            onErrorClick({
                ...item.sticker,
                dayOfTheWeek: item.dayOfTheWeek || item.sticker.dayOfTheWeek,
            });
        }
    };

    // Group errors by day in week order
    const groupedErrors = DAY_ORDER.reduce((acc, day) => {
        const dayErrors = (scheduleErrors || []).filter(e => e.dayOfTheWeek === day);
        if (dayErrors.length > 0) acc[day] = dayErrors;
        return acc;
    }, {});

    return (
        <div className={styles.panel}>
            <div className={styles.panelHeader}>
                <span className={styles.panelTitle}>Schedule Conflicts</span>
                <button
                    className={styles.closeBtn}
                    onClick={loadingErrors ? null : (() => setIsOpenHistoryNotification(false))}
                >
                    ✕
                </button>
            </div>

            {loadingErrors ? (
                <div className={styles.centered}>
                    <Spinner animation="border" role="status" size="sm">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <p className={styles.hintText}>Checking for conflicts…</p>
                </div>
            ) : !scheduleErrors || scheduleErrors.length === 0 ? (
                <div className={styles.centered}>
                    <span className={styles.successIcon}>✓</span>
                    <p className={styles.successText}>No conflicts found</p>
                </div>
            ) : (
                <div className={styles.errorList}>
                    <p className={styles.hintText}>Click an error to jump to it on the schedule</p>
                    {Object.entries(groupedErrors).map(([day, errors]) => (
                        <div key={day} className={styles.dayGroup}>
                            <div className={styles.dayHeader}>
                                {day}
                                <span className={styles.dayCount}>{errors.length}</span>
                            </div>
                            {errors.map((item, index) => {
                                const isOverlap = item.errorType === 'studentOverlap';
                                const conflictingNames = item.conflictingStudentNames || [];

                                return (
                                    <div
                                        key={item.id || `${item.errorMessage}-${index}`}
                                        className={styles.errorCard}
                                        onClick={() => handleErrorClick(item)}
                                        title="Click to navigate to this class on the schedule"
                                        style={{ borderLeftColor: getErrorStyle(item.errorType).border }}
                                    >
                                        <div className={styles.errorCardTop}>
                                            <span className={styles.className}>
                                                {item.sticker?.className || '—'}
                                            </span>
                                            <span className={styles.errorTypeTag} style={{
                                                background: getErrorStyle(item.errorType).tagBg,
                                                color: getErrorStyle(item.errorType).tagColor,
                                                borderColor: getErrorStyle(item.errorType).tagBorder,
                                            }}>
                                                {ERROR_TYPE_LABEL[item.errorType] || item.errorType}
                                            </span>
                                        </div>
                                        <p className={styles.errorMsg}>{item.errorMessage}</p>
                                        {isOverlap && conflictingNames.length > 0 && (
                                            <p className={styles.detailLine}>
                                                <strong>Students:</strong> {conflictingNames.join(', ')}
                                            </p>
                                        )}

                                        <span className={styles.jumpHint}>→ Jump to class</span>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HistoryNotification;
